import { sendGTMEvent } from '@/modules/common/services/sendGTMEvent';
import { DATA_LAYER_EVENTS } from '@/modules/product/services/data-layer-events/events';

type closeDataLayerEventProps = {
  feature: string;
  where?: string;
};

export function closeDataLayerEvent({ feature, where }: closeDataLayerEventProps) {
  sendGTMEvent({ ecommerce: null, eventData: null });
  sendGTMEvent({
    event: DATA_LAYER_EVENTS.close,
    eventData: { feature, where },
  });
}
